import { createFileRoute } from '@tanstack/react-router';

import { AccountPage } from '../../pages/settings';

export const Route = createFileRoute('/_shell/settings/account')({
  component: AccountPage,
});
